<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import GroupCreate from '../../../../groups/components/GroupCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        featureFlags: 'groups',
    }
})
</script>

<template>
  <GroupCreate />
</template>